module.exports = window.WebSocket || WebSocket;